// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/es7.weak-map.of.js
// module id = Kb3C
// module chunks = 1